enum SyncType {
  Manual,
  Auto,
  BypassCache,
}

export default SyncType;
